// extracted by mini-css-extract-plugin
module.exports = {"dieta_order":"OrderBar_dieta_order__2Y77G","order_label":"OrderBar_order_label__2qUul"};